import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, Mail, ArrowRight } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("admin@faisalcarbazar.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  React.useEffect(() => { document.title = "Admin Login — Faisal Car Bazar"; }, []);

  if (localStorage.getItem("fcb_admin_token")) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("fcb_admin_token", data.access_token);
      localStorage.setItem("fcb_admin_email", data.email);
      toast.success("Welcome back!");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center p-6 bg-[#0A0A0A]">
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://images.unsplash.com/photo-1622046120199-32f27980473d?auto=format&fit=crop&w=1600&q=80"
          alt="bg"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] to-[#0A0A0A]/40" />
      </div>
      <form onSubmit={submit} className="relative w-full max-w-md glass rounded-2xl p-10" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-12 h-12 rounded-full bg-[#DC143C] flex items-center justify-center font-display text-2xl text-white shadow-lg shadow-[#DC143C]/30">F</span>
          <div>
            <div className="font-display text-xl text-[#F5F5DC]">Admin Console</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">Faisal Car Bazar</div>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] mb-2">Email</label>
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-[#A0A0A0]" size={16} />
              <input
                data-testid="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full bg-[#1A1A1A] border border-white/10 rounded-lg pl-11 pr-4 py-3 text-[#F5F5DC] focus:border-[#DC143C] outline-none"
              />
            </div>
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] mb-2">Password</label>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-[#A0A0A0]" size={16} />
              <input
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-[#1A1A1A] border border-white/10 rounded-lg pl-11 pr-4 py-3 text-[#F5F5DC] focus:border-[#DC143C] outline-none"
              />
            </div>
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="btn-primary w-full justify-center mt-8"
        >
          {loading ? "Signing in…" : <>Sign In <ArrowRight size={16} /></>}
        </button>

        <p className="text-xs text-center text-[#A0A0A0] mt-6">
          Secure admin access · Authorized personnel only
        </p>
      </form>
    </div>
  );
}
